import { HelpPageContentViewModel } from '@fora-monorepo/epi-content-common';

export const mockHelpPageContent: HelpPageContentViewModel = {
  ingress: {
    body: '<p>Mock content ingress</p>',
  },
  helpSections: [
    { body: '<p>Help section 1</p>' },
    { body: '<p>Help section 2</p>', links: [{ text: 'Läs mer', url: 'https://www.fora.se' }] },
  ],
};
